import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgxSplideModule } from 'ngx-splide';
import { sliderOptions } from '@app/domain/properties/slider.properties';

@Component({
  selector: 'bingo-how-it-works-cricket',
  imports: [NgxSplideModule],
  templateUrl: './how-it-works-cricket.component.html',
  styleUrl: './how-it-works-cricket.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HowItWorksCricketComponent {
  protected readonly sliderOptions = sliderOptions;
}
